import React, { useState } from 'react';
import { BiSolidNote } from 'react-icons/bi';

import { PSButton } from '@/components/ui/button';

import { IRenderCard } from '../../../../common/react-drag-hierarchy-tree-main/src/components/interfaces';
import NoteForm, { INote } from '../../NoteForm';
import { AcceptableItemsToAddType } from './text-scenario.component';

interface ITreeNode {
  originalRenderData: IRenderCard;
  data: {
    name: AcceptableItemsToAddType;
    id: string;
    icon: React.ReactNode;
    acceptableBlocks: AcceptableItemsToAddType[];
    label: React.ReactNode;
    colors: {
      primary: string;
      secondary: string;
      text: string;
    };
  };
  isActive: boolean;
  children?: React.ReactNode;
  onClickToEdit: (data: any, type: any) => void;
  notes?: Array<INote>;
}

const TreeNode = ({ originalRenderData, data, children, isActive, onClickToEdit, notes }: ITreeNode) => {
  const [showNote, setShowNote] = useState(false);
  return (
    <div className="tw-flex tw-items-center tw-min-w-36 grabbable" id={data?.id}>
      <div
        className={`tw-bg-white tw-rounded-full tw-min-w-36 tw-max-w-52 tw-mx-2 ${
          isActive ? 'tw-border-solid tw-border-4 tw-border-blue-600 tw-shadow-inner tw-p-1' : 'tw-border-none'
        } `}
      >
        {notes && notes?.length > 0 && (
          <div
            role="button"
            tabIndex={0}
            id={`btn-node-notes`}
            onMouseEnter={() => setShowNote(true)}
            onMouseLeave={() => setShowNote(false)}
            onFocus={() => setShowNote(true)}
            onBlur={() => setShowNote(false)}
            className={`tw-absolute tw-bottom-[-10px] tw-left-[-4px] tw-w-[30px] tw-h-[30px] tw-gap-2 tw-rounded-full ${
              showNote ? 'tw-bg-blue-500' : 'tw-bg-gray-900'
            }`}
          >
            <BiSolidNote size={18} className="tw-text-gray-100" />
          </div>
        )}
        <button
          id="btn-edit-node"
          key={data?.name}
          className={`grabbable tw-h-11 tw-pl-3 tw-border-none tw-pr-4 tw-py-2 tw-rounded-[99px] tw-justify-start tw-items-center tw-gap-2 tw-inline-flex tw-w-full tw-shrink-0`}
          style={{ backgroundColor: data?.colors.primary }}
          onClick={() => onClickToEdit(originalRenderData.data, originalRenderData.data.type)}
        >
          <div
            className="tw-px-1 tw-pt-[3px] tw-pb-[5px] tw-rounded-[99px] tw-justify-start tw-items-center tw-gap-2.5 tw-flex"
            style={{ backgroundColor: data?.colors.secondary }}
          >
            <div className="tw-w-5 tw-h-5 tw-relative tw-flex tw-flex-col tw-items-center tw-justify-center">{data?.icon}</div>
          </div>
          <div
            className="tw-max-w-[90%] tw-text-sm tw-font-semibold tw-font-['Lexend'] tw-leading-tight tw-truncate ..."
            style={{ color: data?.colors.text }}
            title={typeof data?.label === 'string' ? data?.label : ''}
          >
            {data?.label}
          </div>
        </button>
      </div>

      {children}
      {showNote && <NoteForm data={notes} preview={true} />}
    </div>
  );
};

export default TreeNode;
